import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Image from "next/image";

import ListTile from "@kikoff/components/src/v1/info/ListTile";
import { webRPC } from "@kikoff/proto/src/rpc";
import { format } from "@kikoff/utils/src/string";

import PageAlign from "@component/dashboard/offer/page_align";
import { PageRegistration } from "@component/flows/hooks/usePageFlow";
import { ENABLE_AUTO_PAY_DISCOUNT } from "@constant/promos";
import { applyPromo } from "@feature/promo";
import { fetchUser, selectPromo } from "@feature/user";
import { track } from "@util/analytics";
import { autoPayState } from "@util/payments";

import rocket from "./assets/rocket.svg";

interface AutopayDiscountViewProps extends PageRegistration {
  creditLineToken: string;
}

export default function AutopayDiscountView({
  configFlow,
  Button,
  creditLineToken,
  page,
}: AutopayDiscountViewProps) {
  const dispatch = useDispatch();
  const enableAutopayDiscountPromo = useSelector(
    selectPromo(ENABLE_AUTO_PAY_DISCOUNT)
  );

  configFlow
    .button(
      <Button
        onClick={async () => {
          track.tap(
            "CA - Payment - Basic Autopay Discount - Turn On Autopay Button"
          );
          await webRPC.CreditLine.updateCreditLineSettings({
            creditLineToken,
            autoPay: {
              state: autoPayState(true),
            },
          });

          if (enableAutopayDiscountPromo?.name) {
            await dispatch(
              applyPromo({ promoName: enableAutopayDiscountPromo.name })
            );
          }
          await dispatch(fetchUser.creditLine());
        }}
      >
        Turn on autopay
      </Button>
    )
    .button(
      <Button.Secondary
        variant="text-underline"
        onClick={() => {
          track.tap(
            "CA - Payment - Basic Autopay Discount - Maybe Later Button"
          );
          page.controller.next();
        }}
      >
        Maybe later
      </Button.Secondary>
    );

  return (
    <PageAlign>
      <div className="text-center my-3">
        <Image src={rocket} />
      </div>
      <header className="text:heading-3 mb-2">Save more with autopay!</header>
      <div className="color:moderate mb-1">
        Enable autopay to get $1 off your second month.
      </div>
      <ListTile
        title="Second payment amount"
        trailing={
          <div className="text:small">
            <s className="color:moderate">{format.money(500)}</s>{" "}
            <span className="text:+ color:primary">{format.money(400)}</span>
          </div>
        }
      />
    </PageAlign>
  );
}
